import { render, staticRenderFns } from "./uploadCandidate.vue?vue&type=template&id=4dd53372"
import script from "./uploadCandidate.vue?vue&type=script&lang=js"
export * from "./uploadCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports